import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function getFreight(itemNo: string | undefined, postalCode: string | undefined) {
    if (!itemNo || !postalCode) {
        return Promise.reject(new Error(shopErrors.invalidItemNoOrPostalCode.message));
    }

    const url = getUrl(`/freight/price/${itemNo}`);

    if (postalCode) {
        url.searchParams.set('postalCode', postalCode);
    }

    return shop.get(url).json<ShopTypes.DeliveryPriceDetails>();
}
